import { render, staticRenderFns } from "./footer-default.vue?vue&type=template&id=4330050d"
import script from "./footer-default.vue?vue&type=script&lang=js"
export * from "./footer-default.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports